import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Platform } from '@ionic/angular';
@ Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  product: any;
  dataForNextScreen: any;
  public editDraft = false;
  public draft: any;
  public editQuotation = false;
  public draftId: number;
  public quotation: any;
  public platformReady = false;
  public isEditProduct = false;
  public selectedUser: any;
  constructor(public storage: Storage, public platform: Platform) {
    platform.ready().then(() => {
      this .platformReady = true;
  });
  }

  setLoggedIn(value: any) {
    if (this .platformReady) {
      this .storage.set(`setting:user`, value);
    }
    // this.pref.store('loggedIn', _value);
  }
  async getLoggedInUser() {
    return await this .storage.get(`setting:user`);
  }
  setAuthenticated(value: any) {
    if (!this .platformReady) {
    this .storage.set(`setting:auth`, value);
    }
  }
  async isAuthenticated() {
    // this.pref.fetch('loggedIn').then((res) => {
    //   console.log(res);
    //   return res;
    // }
    // );
    return  await this .storage.get(`setting:auth`);
  }

   setProduct(data: any) {
    this .product = data;
  }

  getProduct() {
    return  this .product;
  }

  setDataForNextScreen(data: any) {
    this .dataForNextScreen = data;
  }

  getDataForNextScreen(): any {
   return this .dataForNextScreen;
  }

  setSelectedUser(data: any) {
    this .selectedUser = data;
  }

  getSelectedUser(): any {
   return this .selectedUser;
  }
  logout() {
    this .storage.clear();
  }
}
